import React, {Component} from 'react'

export default class Hlmpricing extends Component {
  render() {
    return (
      <div className="">
        <div className=" ">
          {/* DESKTOP */}
          <div className="  text-center pt-8 " style={{}}>
            <div className="container grid-xl  pt-2   "></div>
            <div className="container grid-xl  text-dark  th-home--mobilehide   tabcon">
              {/* <div className=" bg-white pt-4 pb-4" style={{paddingLeft: '1.2rem'}}>
                <div className="h2   th-home--mobilefonth2 th-home--padmob text-dark" style={{}}>
                  Simple, straightforward pricing
                </div>
              </div> */}

              <div className="tabs-content-wrap container grid-xl " style={{}}>
                {/* BASIC */}
                <input name="tab" id="basic" type="radio" checked />
                <div class="tab-content2">
                  <div id="basic" className="  ">
                    <div className=" text-dark th-home--mobilehide tabcon" style={{paddingLeft: '4rem'}}>
                      <div className="container grid-md tabs-container3 ">
                        <label for="basic" style={{fontSize: '.8rem', borderBottom: '2px solid #273753'}}>
                          BASIC PLAN (FREE)
                        </label>
                        <label for="pro" style={{fontSize: '.8rem', margin: '0 5.2rem'}}>
                          PRO MEMBERSHIP
                        </label>
                      </div>
                    </div>
                    <div className="container grid-xl  pb-4 tabs-line2"></div>
                    <div className="h4 text-dark th-home--mobilefonthh4 text-center pt-12">BASIC PLAN (FREE)</div>

                    <div class=" container grid-xl bg-transparent  pt-2  ">
                      <div className="p th-home--mobilefontp-sm text-center">
                        Best for: part-time, once-in-a-while, helping out. Create and share Listing Information Packets + Access to Closing Services
                      </div>
                    </div>

                    <div className=" container grid-xl px-8  pb-2 pt-2">
                      <div class="columns " style={{marginBottom: '-1.5rem'}}>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head ">Pre-Market</li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Easy TC/Assistant access</li>
                              <li>Seller Disclosures form filling</li>
                              <li>Create comprehensive Listing Info Packages</li>
                              <li style={{color: '#e2e2e2'}}>Scan documents</li>
                              <li style={{color: '#e2e2e2'}}>Save custom document templates </li>
                            </ul>
                          </ul>
                        </div>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              On-Market
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Share unlimited Listing Information Packages</li>
                              <li>Sharable link for marketing materials</li>
                              <li style={{color: '#e2e2e2'}}>Buyer Interest Reports (activity tracking)</li>
                              <li style={{color: '#e2e2e2'}}>Broadcast updates to viewers </li>
                              <li style={{color: '#e2e2e2'}}>Blind copy mass messaging to clients </li>
                            </ul>
                          </ul>
                        </div>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              Offers
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Receive offers</li>
                              <li>Submit offers</li>
                              <li>Accept offers</li>
                              <li>Automatic offers terms comparison sheet</li>
                              <li style={{color: '#e2e2e2'}}>Custom offers dashboard for sellers&nbsp;</li>
                            </ul>
                          </ul>
                        </div>
                      </div>

                      <div class="columns ">
                        <div class="column  col-4 pt-2 bg-transparent text-center  " style={{marginTop: '-.49rem'}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              Administrative
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Unlimited space (no fee for storage)</li>
                              <li>Easy TC/Assistant access</li>
                              <li>DocuSign integration</li>
                              <li>Easy export of all data & contacts</li>

                              <li style={{color: '#e2e2e2'}}>Custom branding</li>
                            </ul>
                          </ul>
                        </div>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              Support
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Help center guides and training</li>
                              <li style={{color: '#e2e2e2'}}>1-on-1 customer support</li>
                              <li style={{color: '#e2e2e2'}}>Team training </li>
                            </ul>
                          </ul>
                        </div>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              Agent & Client Services
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Buy Before You Sell™</li>
                              <li>Closing Services</li>
                              <li>
                                *Agent approval required,&nbsp;
                                <a href="https://agents.homelight.com/buy-before-you-sell" style={{textDecoration: 'underlin', color: '#465aff'}}>
                                  learn more here
                                </a>
                                .
                              </li>
                            </ul>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* BASIC */}

                {/* PRO MEMEBRSHIP */}
                <input name="tab" id="pro" type="radio" checked />
                <div class="tab-content2">
                  <div id="pro" className="  ">
                    <div className=" text-dark th-home--mobilehide  tabcon" style={{paddingLeft: '4rem'}}>
                      <div className="container grid-md tabs-container3">
                        <label for="basic" style={{fontSize: '.8rem'}}>
                          BASIC PLAN (FREE)
                        </label>
                        <label for="pro" style={{fontSize: '.8rem', margin: '0 5.2rem', borderBottom: '2px solid #46b6ff'}}>
                          PRO MEMBERSHIP
                        </label>
                      </div>
                    </div>
                    <div className="container grid-xl  pb-4 tabs-line2"></div>
                    <div className="h4 text-dark th-home--mobilefonthh4 text-center pt-12">PRO MEMBERSHIP ($39/mo)</div>

                    <div class=" container grid-md bg-transparent  pt-2 ">
                      <div className="p th-home--mobilefontp-sm    text-center">
                        For full-time agents putting up numbers! Manage listings + track activity + group messaging.
                      </div>
                    </div>

                    <div className=" container grid-xl px-8  pb-2 pt-2">
                      {/* TOP PRICING */}
                      <div class="columns " style={{marginBottom: '-1.5rem'}}>
                        <div class="column  col-4  bg-transparent text-center  ">
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head ">Pre-Market</li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Easy TC/Assistant access</li>
                              <li>Seller Disclosures form filling</li>
                              <li>Create comprehensive Listing Info Packages</li>
                              <li style={{color: ' #46b6ff'}}>Scan documents</li>
                              <li style={{color: ' #46b6ff'}}>Save custom document templates </li>
                            </ul>
                          </ul>
                        </div>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              On-Market
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Share unlimited Listing Information Packages</li>
                              <li>Sharable link for marketing materials</li>
                              <li style={{color: ' #46b6ff'}}>Buyer Interest Reports (activity tracking)</li>
                              <li style={{color: ' #46b6ff'}}>Broadcast updates to viewers </li>
                              <li style={{color: ' #46b6ff'}}>Blind copy mass messaging to clients </li>
                            </ul>
                          </ul>
                        </div>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              Offers
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Receive offers</li>
                              <li>Submit offers</li>
                              <li>Accept offers</li>
                              <li>Automatic offers terms comparison sheet</li>
                              <li style={{color: ' #46b6ff'}}>Custom offers dashboard for sellers&nbsp;</li>
                            </ul>
                          </ul>
                        </div>
                      </div>
                      {/* TOP PRICING */}

                      {/* BOTTOM PRICING */}
                      <div class="columns ">
                        <div class="column  col-4 pt-2 bg-transparent text-center  " style={{marginTop: '-.49rem'}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              Administrative
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Unlimited space (no fee for storage)</li>
                              <li>Easy TC/Assistant access</li>
                              <li>DocuSign integration</li>
                              <li>Easy export of all data & contacts</li>
                              <li style={{color: ' #46b6ff'}}>Custom branding</li>
                            </ul>
                          </ul>
                        </div>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              Support
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Help center guides and training</li>
                              <li style={{color: ' #46b6ff'}}>1-on-1 customer support</li>
                              <li style={{color: '#e2e2e2'}}>Team training </li>
                            </ul>
                          </ul>
                        </div>
                        <div class="column  col-4  bg-transparent text-center  " style={{}}>
                          <ul
                            className="  th-home--planul"
                            style={{
                              listStyleType: 'none',
                              flex: 1,
                              lineHeight: '.9rem',
                              textAlign: 'left',
                              padding: '1rem',
                              color: '#00414b',
                            }}>
                            <li class="ul-price-head " style={{fontWeight: 'bolder'}}>
                              Agent & Client Services
                            </li>
                            <ul className=" text-small " style={{listStyleType: 'none', flex: 1, lineHeight: '.9rem', textAlign: 'left', color: '#00414b'}}>
                              <li>Buy Before You Sell™</li>
                              <li>Closing Services</li>
                              <li>
                                *Agent approval required,&nbsp;
                                <a href="https://agents.homelight.com/buy-before-you-sell" style={{textDecoration: 'underlin', color: '#465aff'}}>
                                  learn more here
                                </a>
                                .
                              </li>
                            </ul>
                          </ul>
                        </div>
                      </div>

                      {/* BOTTOM PRICING */}
                    </div>
                  </div>
                </div>
                {/* PRO MEMBERSHIP */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
